// extracted by mini-css-extract-plugin
export var whyAttend = "WhyAttend-module--whyAttend--1RRzf";
export var wordsContent = "WhyAttend-module--wordsContent--3m36D";
export var insights = "WhyAttend-module--insights--8dR4T";
export var heading = "WhyAttend-module--heading--1K2g6";
export var numbers = "WhyAttend-module--numbers--3aN3d";
export var saveSeatLink = "WhyAttend-module--saveSeatLink--14E_6";
export var arrowPink = "WhyAttend-module--arrowPink--3PUWA";
export var paragraph = "WhyAttend-module--paragraph--2GW_a";
export var insightsCard = "WhyAttend-module--insightsCard--OccY8";
export var number = "WhyAttend-module--number--3gWha";
export var description = "WhyAttend-module--description--1mEh6";